import canonicalize from '../../../../services/canonicalize';

export const name = 'canonicalize';
export const defaultProp = true;
export const onParse = s => canonicalize(s).content;
